export default class Logs {
  client

  constructor(client) {
    this.client = client
  }

  /**
   * Get log lines
   * @param {Object} params - The pods overview parameters
   * @param {string} params.site_id - The site ID
   * @param {string} params.from - from timestamp
   * @param {string} params.to - to timestamp
   * @param {string} [params.source_ids] - Array of source IDs
   * @param {string} params.query - The query string
   * @param {Object} params.pagination - Pagination parameters
   * @param {string} params.pagination.order - The order of the results
   * @param {string} params.pagination.per_page - The number of items per page
   * @param {Object} params.pagination.cursor - The cursor for pagination
   * @param {string} params.pagination.cursor.time - The time of the cursor
   * @param {string} params.pagination.cursor.id - The ID of the cursor
   * @param {Object} [options={}] - Optional request options
   * @returns {Promise} The API response
   */
  lines(params, options = {}) {
    return this.client.post("/api/v2/logs/lines", { ...params, use_expressions: true }, options)
  }

  /**
   * Get log lines via streaming for real-time data
   * @param {Object} params - The log query parameters
   * @param {string} params.site_id - The site ID
   * @param {string} params.from - from timestamp
   * @param {string} params.to - to timestamp
   * @param {string[]} [params.source_ids] - Array of source IDs
   * @param {string} [params.query] - The query string
   * @param {Object} [params.pagination] - Pagination parameters
   * @param {Object} [options={}] - Optional request options
   * @returns {Promise<Response>} The streaming response
   */
  linesStream(params, options = {}) {
    // Use same structure as regular lines method but with streaming headers
    const requestBody = {
      site_id: params.site_id,
      from: params.from,
      to: params.to,
      source_ids: params.source_ids || [],
      use_expressions: true,
      query: params.query || "",
      pagination: params.pagination || {
        per_page: 100,
        order: "DESC",
        cursor: {
          time: null,
        },
      },
    }

    return this.client.postStream("/api/v2/logs/lines", requestBody, options)
  }
}
